import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrintPolicy = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "printPolicy",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16830",
		"data-name": "Group 16830",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12479",
				"data-name": "Path 12479",
				d: "M16.814,8V4a1,1,0,0,0-1-1H8.186a1,1,0,0,0-1,1V8",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12480",
				"data-name": "Path 12480",
				d: "M17,11h1",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12481",
				"data-name": "Path 12481",
				d: "M7,17H4a1,1,0,0,1-1-1V9A1,1,0,0,1,4,8H20a1,1,0,0,1,1,1v7a1,1,0,0,1-1,1H17",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12482",
				"data-name": "Path 12482",
				d: "M16,21H8a1,1,0,0,1-1-1V14H17v6A1,1,0,0,1,16,21Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12483",
		"data-name": "Path 12483",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgPrintPolicy;
